import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e615096"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner1" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title_left" }, "ユーザー登録・編集")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "error-message"
}
const _hoisted_8 = { class: "" }
const _hoisted_9 = { style: {"width":"100%"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"14%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"18%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"6%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"16%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"6%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"16%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"8%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"16%"} })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode(" エージェントコード ")
], -1))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "会社名", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "部署名", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "担当者名", -1))
const _hoisted_17 = { style: {"width":"100%"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"11%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"26%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"6%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"21%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"6%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"21%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"9%"} })
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "メールアドレス", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "備考１", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "備考２", -1))
const _hoisted_22 = { class: "form-control-title" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_24 = { class: "" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "件数：", -1))
const _hoisted_26 = {
  key: 0,
  class: ""
}
const _hoisted_27 = { class: "table table-bordered" }
const _hoisted_28 = { class: "thead-light" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_selection" }, "削除", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_btnUpdate" }, "編集", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_bikou1" }, "備考１", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_bikou2" }, "備考２", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_roleDisplayName" }, "権限", -1))
const _hoisted_34 = {
  "data-name": "mSelection",
  style: {"text-align":"center"}
}
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = {
  "data-name": "mBtnUpdate",
  style: {"text-align":"center"}
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { "data-name": "mKaisyaName" }
const _hoisted_39 = { "data-name": "mBusyoName" }
const _hoisted_40 = { "data-name": "mTantousyaName" }
const _hoisted_41 = { "data-name": "mEmail" }
const _hoisted_42 = { "data-name": "mBikou1" }
const _hoisted_43 = { "data-name": "mBikou2" }
const _hoisted_44 = { "data-name": "mKanriKengen" }
const _hoisted_45 = { class: "form-inline flex-container" }
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"right"} }, " ※：エージェントコード変更して検索する場合もクリアボタンを押下してください。 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_content_pagination = _resolveComponent("content-pagination")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _hoisted_6,
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_11,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("select", {
                        id: "agCode",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agUserSearchCond.agCode) = $event)),
                        disabled: !_ctx.isAgCodeDataListMultiple || !_ctx.isSearchMode,
                        class: "form-control"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agCodeDataList, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.value,
                            value: item.value
                          }, _toDisplayString(item.value + " " + item.text), 9, _hoisted_13))
                        }), 128))
                      ], 8, _hoisted_12), [
                        [_vModelSelect, _ctx.agUserSearchCond.agCode]
                      ])
                    ]),
                    _hoisted_14,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        id: "kaisyaName",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.agUserSearchCond.kaisyaName) = $event)),
                        type: "text",
                        placeholder: "会社名",
                        maxlength: "255",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.agUserSearchCond.kaisyaName]
                      ])
                    ]),
                    _hoisted_15,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        id: "busyoName",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.agUserSearchCond.busyoName) = $event)),
                        type: "text",
                        placeholder: "部署名",
                        maxlength: "255",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.agUserSearchCond.busyoName]
                      ])
                    ]),
                    _hoisted_16,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        id: "tantousyaName",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.agUserSearchCond.tantousyaName) = $event)),
                        type: "text",
                        placeholder: "担当者名",
                        maxlength: "255",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.agUserSearchCond.tantousyaName]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("table", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_19,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        id: "email",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.agUserSearchCond.email) = $event)),
                        type: "text",
                        placeholder: "メールアドレス",
                        maxlength: "255",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.agUserSearchCond.email]
                      ])
                    ]),
                    _hoisted_20,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        id: "bikou1",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.agUserSearchCond.bikou1) = $event)),
                        type: "text",
                        placeholder: "備考１",
                        maxlength: "255",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.agUserSearchCond.bikou1]
                      ])
                    ]),
                    _hoisted_21,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        id: "bikou2",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.agUserSearchCond.bikou2) = $event)),
                        type: "text",
                        placeholder: "備考２",
                        maxlength: "255",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.agUserSearchCond.bikou2]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_22, [
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnSearch",
                        class: "btn btn-primary",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
                      }, " 検索 ")
                    ])
                  ])
                ])
              ])
            ]),
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              (!_ctx.isSearchMode)
                ? (_openBlock(), _createElementBlock("label", _hoisted_26, _toDisplayString(_ctx.agUserDataList.length.toLocaleString()) + " 件 ", 1))
                : _createCommentVNode("", true),
              _createElementVNode("table", _hoisted_27, [
                _createElementVNode("thead", _hoisted_28, [
                  _createElementVNode("tr", null, [
                    _hoisted_29,
                    _hoisted_30,
                    _createElementVNode("th", {
                      class: _normalizeClass([
                  'col_kaisyaName',
                  'sortable',
                  _ctx.isDirectionASC('kaisyaName') ? 'asc' : 'desc',
                ]),
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSortItem('kaisyaName')))
                    }, " 会社名 ", 2),
                    _createElementVNode("th", {
                      class: _normalizeClass([
                  'col_busyoName',
                  'sortable',
                  _ctx.isDirectionASC('busyoName') ? 'asc' : 'desc',
                ]),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSortItem('busyoName')))
                    }, " 部署名 ", 2),
                    _createElementVNode("th", {
                      class: _normalizeClass([
                  'col_tantousyaName',
                  'sortable',
                  _ctx.isDirectionASC('tantousyaName') ? 'asc' : 'desc',
                ]),
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onSortItem('tantousyaName')))
                    }, " 担当者名 ", 2),
                    _createElementVNode("th", {
                      class: _normalizeClass([
                  'col_email',
                  'sortable',
                  _ctx.isDirectionASC('email') ? 'asc' : 'desc',
                ]),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onSortItem('email')))
                    }, " メールアドレス ", 2),
                    _hoisted_31,
                    _hoisted_32,
                    _hoisted_33
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedData, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.userId
                    }, [
                      _createElementVNode("td", _hoisted_34, [
                        _withDirectives(_createElementVNode("input", {
                          id: "mSelection",
                          "onUpdate:modelValue": ($event: any) => ((item.selection) = $event),
                          type: "checkbox",
                          class: "form-check-input"
                        }, null, 8, _hoisted_35), [
                          [_vModelCheckbox, item.selection]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_36, [
                        _createElementVNode("button", {
                          type: "button",
                          name: "mBtnUpdate",
                          class: "btn btn-primary btn-sm",
                          onClick: ($event: any) => (_ctx.showUpdate(item.userId))
                        }, " 編集 ", 8, _hoisted_37)
                      ]),
                      _createElementVNode("td", _hoisted_38, _toDisplayString(item.kaisyaName), 1),
                      _createElementVNode("td", _hoisted_39, _toDisplayString(item.busyoName), 1),
                      _createElementVNode("td", _hoisted_40, _toDisplayString(item.tantousyaName), 1),
                      _createElementVNode("td", _hoisted_41, _toDisplayString(item.email), 1),
                      _createElementVNode("td", _hoisted_42, _toDisplayString(item.bikou1), 1),
                      _createElementVNode("td", _hoisted_43, _toDisplayString(item.bikou2), 1),
                      _createElementVNode("td", _hoisted_44, _toDisplayString(item.roleDisplayName), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createVNode(_component_content_pagination, {
                "current-page": _ctx.currentPage,
                "total-pages": _ctx.totalPages,
                "items-per-page": _ctx.itemsPerPage,
                onPageChanged: _ctx.handlePageChange
              }, null, 8, ["current-page", "total-pages", "items-per-page", "onPageChanged"]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnDelete",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args))),
                    disabled: _ctx.isSearchMode
                  }, " 削除 ", 8, _hoisted_47)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnBack",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
                  }, " 戻る "),
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnClear",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                  }, " クリア "),
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnAdd",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.showAdd && _ctx.showAdd(...args))),
                    disabled: _ctx.isSearchMode
                  }, " 新規登録 ", 8, _hoisted_49)
                ])
              ]),
              _hoisted_50
            ])
          ])
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}